<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" class="pa-0">
      <v-sheet class="mb-2">
        <v-skeleton-loader type="article" v-if="loading" />
        <v-col v-else class="px-6 py-4">
          <v-row class="ma-0"><h2>Personal data</h2></v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="3" class="pa-0">
                  <span class="text-secion-title pr-2">Sex</span>
                </v-col>
                <v-col cols="12" md="4" class="pa-0">
                  <v-select
                    class="select-narrow px-2"
                    :items="['Male', 'Female']"
                    filled
                    v-model="restrictedProfileData.personal.sex"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="3" class="pa-0">
                  <span class="text-section-title pr-2">First name</span>
                </v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="profileData.firstName"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col
                  cols="12"
                  md="3"
                  class="pa-0"
                  :align="$vuetify.breakpoint.mdAndUp ? 'end' : 'start'"
                >
                  <span class="text-section-title pr-2">Last name</span>
                </v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="profileData.lastName"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="3" class="pa-0">
                  <div class="text-section-title">Middle name(s)</div>
                </v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field
                    filled
                    v-model="profileData.middleName"
                    class="field-narrow px-2"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="3" class="pa-0">
                  <div class="text-section-title">D.O.B</div>
                </v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-menu
                    v-model="dobMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        filled
                        class="field-narrow px-2"
                        :value="restrictedProfileData.personal.dob"
                        v-on="on"
                        v-bind="attrs"
                        :clearable="true"
                        @click:clear="removeDOB"
                        readonly
                      />
                    </template>
                    <v-date-picker
                      :value="restrictedProfileData.personal.dob"
                      @input="selectDOB"
                    />
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col
                  cols="12"
                  md="3"
                  class="pa-0"
                  :align="$vuetify.breakpoint.mdAndUp ? 'end' : 'start'"
                >
                  <div class="text-section-title pr-2">N.I. Number</div>
                </v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.personal.niNumber"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-sheet>
      <v-sheet class="mb-2"
        ><v-skeleton-loader type="article" v-if="loading"></v-skeleton-loader>
        <v-col v-else class="px-6 py-4">
          <v-row class="ma-0"><h2>Contact</h2></v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="3" class="pa-0">
                  <div class="text-section-title">Address line 1</div>
                </v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.address.line1"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="3" class="pa-0">
                  <div class="text-section-title">Address line 2</div>
                </v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field
                    filled
                    v-model="restrictedProfileData.address.line2"
                    class="field-narrow px-2"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="3" class="pa-0">
                  <div class="text-section-title">City/Town</div>
                </v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.address.city"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col
                  cols="12"
                  md="3"
                  class="pa-0"
                  :align="$vuetify.breakpoint.mdAndUp ? 'end' : 'start'"
                >
                  <div class="text-section-title pr-2">Postcode</div>
                </v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.address.postcode"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="3" class="pa-0">
                  <div class="text-section-title">Country</div>
                </v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-select
                    filled
                    :items="countries"
                    item-text="name"
                    item-value="name"
                    class="select-narrow px-2"
                    v-model="restrictedProfileData.address.country"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="3" class="pa-0">
                  <div class="text-section-title">Personal mobile</div>
                </v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.personal.mobile"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col
                  cols="12"
                  md="3"
                  class="pa-0"
                  :align="$vuetify.breakpoint.mdAndUp ? 'end' : 'start'"
                >
                  <div class="text-section-title pr-2">Personal landline</div>
                </v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.personal.landline"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-sheet>
      <v-sheet class="mb-2">
        <v-skeleton-loader type="article" v-if="loading" />
        <v-col v-else class="px-6 py-4">
          <v-row class="ma-0"><h2>Bank / Building Society</h2></v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="3" class="pa-0">
                  <div class="text-section-title">Name</div>
                </v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.bank.name"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="3" class="pa-0">
                  <div class="text-section-title">Account number</div>
                </v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.bank.accountNumber"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col
                  cols="12"
                  md="3"
                  class="pa-0"
                  :align="$vuetify.breakpoint.mdAndUp ? 'end' : 'start'"
                >
                  <div class="text-section-title pr-2">Sort code</div>
                </v-col>
                <v-col cols="12" md="9" class="pa-0" justify="center">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.bank.sortCode"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12" md="3" class="pa-0">
                  <div class="text-section-title">Address</div>
                </v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-textarea
                    filled
                    v-model="restrictedProfileData.bank.address"
                    class="px-2"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-sheet>
      <v-sheet>
        <v-skeleton-loader type="article" v-if="loading"></v-skeleton-loader>
        <v-col v-else class="px-6 py-4">
          <v-row class="ma-0"><h2>Car</h2></v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="4" class="pa-0">
                  <div class="text-section-title">Driving license no.</div>
                </v-col>
                <v-col cols="12" md="8" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.personal.drivingLicense"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="4" class="pa-0">
                  <div class="text-section-title">Car registration</div>
                </v-col>
                <v-col cols="12" md="8" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.personal.carReg"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import countryList from 'country-list'

export default {
  props: ['id', 'profileData', 'restrictedProfileData'],
  data: () => ({
    countries: countryList.getData(),
    dobMenu: false,
  }),
  computed: {
    loading() {
      return !this.profileData || !this.restrictedProfileData
    },
    fullName() {
      return [
        this.profileData.firstName ?? '',
        this.profileData.lastName ?? '',
      ].join(' ')
    },
  },
  methods: {
    selectDOB(date) {
      this.restrictedProfileData.personal.dob = date
      this.dobMenu = false
    },
    removeDOB() {
      delete this.restrictedProfileData.personal.dob
    },
  },
}
</script>

<style lang="sass" scoped>
.avatar-name
  @include tabInactive
</style>


